module.exports = __webpack_public_path__ + "img/homeslide4-min.eccaa93c.jpg";